//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import cfr from './cfrList'
    export default{
        name:'bb_form_b',
         components: {
            cfr
        },
        data(){
            return{
                get_host:host.host,
                showCfrList:false,
                list_id:'',
                cfrText:'',
                form:{
                    room:'',
                    card:'',
                    name:'',
                    baby_id:'',
                    sex:'',
                    momName:'',
                    date:'',
                    birtherDay:'',
                    weight:'',
                    bobyWeight:'',
                    voice:'响亮',
                    temperature:'',
                    urinate:'',
                    bowelsNum:'',
                    bowelsColor:'',
                    bowelsNature:'',
                    fontanelle:'1',
                    front_case:'',
                    skin:'1',
                    instruction:'',
                    signature:'',
                    shifts:'',
                    check_id:''
                },
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                baby_list:[],
                child_birth:''
            }
        },
        created(){
            this.get_baby_list()
            this.apiMemberInfo()
            if(this.$route.query.list_id){
                 this.apiGetCfrList()
                // this.apiDetail()
                this.list_id = this.$route.query.list_id
            }else{
                this.list_id = ''
                this.form.instruction = '母乳喂养、母婴同室'
            }
        },
        methods:{
            GetNumberOfDays(date1,date2){//获得天数
                //date1：开始日期，date2结束日期
                var a1 = Date.parse(new Date(date1));
                var a2 = Date.parse(new Date(date2));
                var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                return day
            },
            change_date(value){
                console.log(this.child_birth)
                this.apiMemberInfo(value)
            },
            //获取查房人列表
            apiGetCfrList(){
                let params = {
                    token: this.$cookie.get('token'),
                    store_id:this.$cookie.get('store_id'),
                }
                Api.checkRoomApi.getCheckInfo(params).then ( res => {
                    console.info("获取查房人列表",res)
                    if(res.errcode == 1){
                        this.nurser_name = res.data.nurser_name//过滤了离院，
                        this.apiDetail()
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
             //点击选择查房人
            selectPeople(){
                this.showCfrList = true
            },
            //赋值查房人ID
            cfrListEven(val,item){
                this.showCfrList = val
                console.info(item)
                if(item){
                    this.form.check_id = item.id
                    this.cfrText = item.user_name
                }
            },
            //获取前囟input值
            onChangeFontanelle(val){
                this.form.fontanelle=val
                this.$refs.fontanelle.focus()
                this.showFontanellePicker=false
            },
            checkerChange(value){
                for(let item of this.baby_list){
                    if(item.id == value){
                        if(item.live_time == '0'){
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name+'暂未入住',
                            })
                            return
                        }
                        this.form.card = item.hand_card
                        this.form.sex = item.sex == "1" ? "男" : "女"
                        this.form.name = item.name
                        this.form.birtherDay = item.birth_day
                        // this.form.bobyWeight = item.weight
                    }
                }
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        // this.form.baby_id = res.data[0].id
                        // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //请求用户基本信息
            apiMemberInfo(value){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                        this.child_birth = this.formatDateTime(res.data.child_birth)
                        if(value){
                            let day = this.GetNumberOfDays(this.child_birth,value)+1
                            this.form.birtherDay = day
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            save(){
                let signature ='signature1'
                let png = this.$refs[signature].save()
                this.form.signature = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.signature = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.signature = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.getBabyNursOneFind(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room_number
                        this.form.card = data.id_card
                        this.form.name = data.baby_name
                        this.form.baby_id=data.baby_id
                        this.form.sex = data.baby_gender
                        this.form.momName = data.mom_name
                        this.form.date = data.cat_date
                        this.change_date(data.cat_date)
                        this.form.birtherDay = data.birth_day_num
                        this.form.temperature = data.temperature
                        this.form.weight = data.weight
                        this.form.bobyWeight = data.length
                        this.form.voice = data.cry
                        this.form.urinate = data.urine_num
                        this.form.bowelsNum = data.shit_num
                        this.form.bowelsColor = data.shit_colour
                        this.form.bowelsNature = data.shit_nature
                        this.form.fontanelle = data.front_fontanelle
                        this.form.front_case = data.front_case
                        this.form.skin = data.skin_colour
                        this.form.instruction = data.guiding_pinions
                        this.form.signature = data.autograph.indexOf(this.get_host) != -1 ? data.autograph : this.get_host+data.autograph
                        this.form.shifts =data.shifts
                        this.form.check_id = data.check_id
                        this.showSignature = true
                        if(this.nurser_name.length){
                            for(let item of this.nurser_name){
                                if(item.id == data.check_id){
                                    this.cfrText = item.user_name
                                }
                            }
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let babyName = ''
                for(let item of this.baby_list){
                    if(item.id == this.form.baby_id){
                        babyName = item.name
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    baby_name:babyName,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    cat_date:this.form.date,
                    birth_day_num:this.form.birtherDay,
                    length:this.form.bobyWeight,
                    weight:this.form.weight,
                    cry:this.form.voice,
                    temperature:this.form.temperature,
                    urine_num:this.form.urinate,
                    shit_num:this.form.bowelsNum,
                    shit_colour:this.form.bowelsColor,
                    shit_nature:this.form.bowelsNature,
                    front_fontanelle:this.form.fontanelle,
                    front_case:this.form.front_case,
                    skin_colour:this.form.skin,
                    guiding_pinions:this.form.instruction,
                    autograph:this.form.signature,
                    shifts:this.form.shifts,
                    check_id:  this.form.check_id       
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.addBabyNursOneData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_b',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    baby_name:this.form.name,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    cat_date:this.form.date,
                    birth_day_num:this.form.birtherDay,
                    length:this.form.bobyWeight,
                    weight:this.form.weight,
                    cry:this.form.voice,
                    temperature:this.form.temperature,
                    urine_num:this.form.urinate,
                    shit_num:this.form.bowelsNum,
                    shit_colour:this.form.bowelsColor,
                    shit_nature:this.form.bowelsNature,
                    front_fontanelle:this.form.fontanelle,
                    front_case:this.form.front_case,
                    skin_colour:this.form.skin,
                    guiding_pinions:this.form.instruction,
                    autograph:this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host,'') : this.form.signature,
                    shifts:this.form.shifts,
                    check_id:this.form.check_id            
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.updateBabyNursOneData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_b',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                // 判断宝宝是否入住
                let time = 0
                if(this.baby_list.length){
                    for(let item of this.baby_list){
                        if(item.id == this.form.baby_id){
                            time = item.live_time
                        }
                    }
                }
                if(time == '0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝暂未入住',
                    })
                    return
                }
                let form = this.form
                if(form.card == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入手卡号',
                    })
                    return
                }
                if(form.baby_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择宝宝',
                    })
                    return
                }
                if(form.date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择日期',
                    })
                    return
                }
                if(form.birtherDay == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入出生天数',
                    })
                    return
                }
                if(form.weight == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入体重',
                    })
                    return
                }
                if(form.bobyWeight == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入身长',
                    })
                    return
                }
                if(form.voice == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入哭声',
                    })
                    return
                }
                if(form.temperature == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入体温',
                    })
                    return
                }
                if(form.urinate == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入小便次数',
                    })
                    return
                }
                if(form.bowelsNum == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便次数',
                    })
                    return
                }
                if(form.bowelsNature == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便性质',
                    })
                    return
                }
                if(form.bowelsColor == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便颜色',
                    })
                    return
                }
                if(form.fontanelle == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择前囟情况',
                    })
                    return
                }
                if(form.skin == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入肤色',
                    })
                    return
                }
                if(form.instruction == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入指导意见',
                    })
                    return
                }
                if(form.shifts == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入班次',
                    })
                    return
                }
                if(form.signature == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入签名',
                    })
                    return
                }
                if(form.check_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择查房人',
                    })
                    return
                }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_b.vue